var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"material-symbols-outlined info-icon"},[_vm._v("info_i")])
}
var staticRenderFns = []

export { render, staticRenderFns }